import { useState } from 'react';
import { Box, HStack, Icon, Text, SimpleGrid, Flex, Button } from '@chakra-ui/react';

import format from 'date-fns/format';

import Content from '~/containers/Content';
import PageContainer from '~/containers/PageContainer';
import BackwardBar from '~/components/BackwardBar';
import MealBoxContainer from './MealBoxContainer';
import EmptyContainerPlaceholder from './EmptyContainerPlaceholder';

import { IoFileTrayOutline, IoSync } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import CheckBar from './CheckBar';
import QRCodeModal from './QRCodeModal';

import useContainers from '../hooks/useContainers';

import * as fp from 'lodash/fp';

import { BtnVariant } from '~/theme/components/Button';

export default function ReturnList() {
  const navigate = useNavigate();
  const { customerContainers, handleUpdateCount } = useContainers();
  const [qrCodeModal, setQrCodeModal] = useState<{
    isOpen: boolean;
    returnList: Array<{ id: string; name: string; count: number }>;
  }>({
    isOpen: false,
    returnList: [],
  });

  const todayString = format(new Date(), 'yyyy-MM-dd');
  const selectedContainerCount = customerContainers.reduce((prev, { count }) => prev + count, 0);

  const handleOpenQrCodeModal = () => {
    const returnList = customerContainers
      .filter(({ count }) => count)
      .map(({ id, name, count }) => ({ id, name, count }));

    setQrCodeModal({ isOpen: true, returnList });
  };

  const handleCloseQrCodeModal = () => {
    setQrCodeModal({ isOpen: false, returnList: [] });
  };

  return (
    <PageContainer
      hideHeader
      hideNavBar
      afterHeaderComponent={
        <>
          <BackwardBar title="返回" onNavigate={() => navigate(`/mealBoxRecycling`)} />
          <Box bg="white" px={4} borderBottomWidth="1px" borderBottomColor="primary">
            <Content m="auto">
              <HStack py={2}>
                <Icon as={IoFileTrayOutline} boxSize="1.25rem" color="primary" />
                <Text fontSize="lg" letterSpacing={2}>
                  選擇歸還的餐盒
                </Text>
              </HStack>
            </Content>
          </Box>
        </>
      }
    >
      <Box px={4}>
        <Content py={6} flex={1}>
          {fp.gt(customerContainers.length, 0) ? (
            <>
              <Flex
                mb={3}
                align="center"
                justify="space-between"
                p={2}
                bgColor="gray.100"
                borderRadius="5px"
              >
                <Text fontSize="sm">可刷新確認店家是否已收到歸還餐盒</Text>
                <Button
                  variant={BtnVariant.SOLID_LIGHT}
                  size="sm"
                  leftIcon={<Icon as={IoSync} boxSize="1.25rem" />}
                  onClick={() => window.location.reload()}
                >
                  刷新
                </Button>
              </Flex>
              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
                {customerContainers.map(({ id, name, expiredDate, amount, count }) => (
                  <MealBoxContainer
                    key={id}
                    isExpired={expiredDate < todayString}
                    mealBoxType={name}
                    time={expiredDate}
                    amount={amount}
                    count={count}
                    onUpdateCount={(count) => handleUpdateCount(id, count)}
                  />
                ))}
              </SimpleGrid>
            </>
          ) : (
            <EmptyContainerPlaceholder />
          )}
        </Content>
      </Box>

      {fp.gt(customerContainers.length, 0) && (
        <CheckBar
          title="產生回收驗證碼"
          totalAmount={selectedContainerCount}
          onCheckout={handleOpenQrCodeModal}
        />
      )}
      <QRCodeModal
        isOpen={qrCodeModal.isOpen}
        returnList={qrCodeModal.returnList}
        onClose={handleCloseQrCodeModal}
      />
    </PageContainer>
  );
}
